import { PageTable, Header } from "/src/layouts/page";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";

import ApiModal from "/src/components/modal/ApiModal/ApiModal";

import { useNavigate } from "react-router-dom";
import Table from "/src/components/table";
import "./CompanyTable.css";
import companyService from "../../services/companyService";
import CompanyModal from "../modal/CompanyModal";
import { formatDate } from "/src/utils/formatDate";
import hasPermission from "/src/utils/hasPermission";
import { switchCompany } from "/src/utils/switchCompany";
import { isClient, isAdmin } from "/src/utils/access";

function CompanyTable({ bare = false }) {
    const { getCompanies, deleteCompany } = companyService;
    const navigate = useNavigate();

    const handleSwitch = async (id) => {
        await switchCompany(id, navigate);
    };

    const cells = [
        {
            column: "ID",
            name: "id",
            sort: true,
            show: (value) => value,
        },
        {
            column: "AVATAR",
            name: ["logo", "name", "id"],
            show: ([logo, name, id]) => (
                <img
                    srcSet={logo}
                    title={name}
                    alt=""
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSwitch(id)}></img>
            ),
        },
        {
            column: "ORGANIZATIONS",
            name: ["name", "id"],
            sort: true,
            show: ([name, id]) => (
                <a className="organization-link" onClick={() => handleSwitch(id)}>
                    {name}
                </a>
            ),
        },
        {
            column: "NUMBER OF USERS",
            name: "users",
            sort: true,
            show: (value) => value.length,
        },
        {
            column: "NUMBER OF BOTS",
            name: "bots",
            sort: true,
            show: (value) => value.length,
        },
        {
            column: "CREATION",
            name: "created_at",
            sort: true,
            show: (value) => formatDate(value),
        },
    ];

    const showAddModal = ({ addRow }) =>
        NiceModal.show(CompanyModal, {
            title: "Create a new Organization",
        }).then((company) => addRow(company));

    const showEditModal = ({ updateRow, row }) =>
        NiceModal.show(CompanyModal, {
            title: "Modify your Organization",
            data: { ...row },
        }).then((company) => updateRow(company));

    const onClickShowHistory = ({ row }) => navigate(`/administration/company/logs`, { state: { data: row } });

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, name } = row;
        await ModalManager.show(ApiModal, {
            title: "Delete organization " + name,
            body: "Do you really want to delete organization " + name,
            api: {
                request: deleteCompany,
                param: [row.id],
            },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
            confirm: {
                name: row.name,
                fieldName: "the organization",
            },
        }).then(() => deleteRow(id));
    };

    const onClickSwitch = ({ row }) => {
        const { id } = row;
        handleSwitch(id);
    };

    const actions = [
        hasPermission("update_organization")
            ? { className: "fas fa-cog action-button edit_action", style: {}, onClick: showEditModal }
            : null,
        hasPermission("update_organization")
            ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: onClickSwitch }
            : null,
        hasPermission("update_organization")
            ? { className: "fas fa-history action-button edit_action", style: {}, onClick: onClickShowHistory }
            : null,
        hasPermission("delete_organization")
            ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete }
            : null,
    ].filter((action) => action);

    const buttons = [
        isAdmin ? { icon: "fas fa-search", onClick: ()=> window.open("https://app.talkr.ai/bot/test/86-685-RC6xz54wbbFJgE1TkGmkVkoc6RxHs7Yx","_blank","noopener,noreferrer") } : null,
        hasPermission("create_organization") ? { icon: "fas fa-plus", onClick: showAddModal } : null,
    ].filter((button) => button);

    const filters = [{ type: "input", placeholder: "Name", name: "name" }];

    const content = (
        <>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>

            <Table
                name="Organization"
                cells={cells}
                api={getCompanies}
                actions={actions}
                buttons={buttons}
                filters={filters}></Table>
        </>
    );

    if (bare) {
        return content;
    }

    return (
        <PageTable>
            <Header title="Manage Organizations"></Header>
            {content}
        </PageTable>
    );
}

export default CompanyTable;
